import { render, staticRenderFns } from "./OAuthSuccessCallback.vue?vue&type=template&id=39e2c5cc&lang=pug&"
import script from "./OAuthSuccessCallback.vue?vue&type=script&lang=js&"
export * from "./OAuthSuccessCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports